import React from "react";
import { observer } from "mobx-react";

import { EventOffer, SportOffer } from "@gp/offer";

import { EventTeamsInfo } from "./EventTeamsInfo";
import { LiveEventCurrentStats, LiveEventTimeAndScore } from "./live-event";

export const LiveEventInfo = observer(function LiveEventInfo(props: {
	sport: SportOffer;
	event: EventOffer;
}) {
	return (
		<>
			<EventTeamsInfo event={props.event}>
				<LiveEventTimeAndScore
					sport={props.sport}
					event={props.event}
				/>
			</EventTeamsInfo>

			<LiveEventCurrentStats event={props.event} sport={props.sport} />
		</>
	);
});
